import {
  GET_PROFILE_REQUESTING,
  GET_PROFILE_REQUEST_SUCCESS,
  GET_PROFILE_REQUEST_ERROR,
  BANK_ACC_REQUESTING,
  BANK_ACC_REQUEST_SUCCESS,
  BANK_ACC_REQUEST_ERROR,
  SET_DEFAULT_REQUEST_ERROR,
  SET_DEFAULT_REQUEST_SUCCESS,
  SET_DEFAULT_REQUESTING,
} from './constants';

export const profileRequest = function profileRequest(params) {
  return {
    type: GET_PROFILE_REQUESTING,
    params,
  };
};

export const profileRequestSuccess = function profileRequestSuccess(data) {
  return {
    type: GET_PROFILE_REQUEST_SUCCESS,
    data,
  };
};

export const profileRequestError = function profileRequestError(error) {
  return {
    type: GET_PROFILE_REQUEST_ERROR,
    error,
  };
};

export const bankAccRequest = function bankAccRequest(params) {
  return {
    type: BANK_ACC_REQUESTING,
    params,
  };
};

export const bankAccRequestSuccess = function bankAccRequestSuccess(data) {
  return {
    type: BANK_ACC_REQUEST_SUCCESS,
    data,
  };
};

export const bankAccRequestError = function bankAccRequestError(error) {
  return {
    type: BANK_ACC_REQUEST_ERROR,
    error,
  };
};

export const setDefaultRequest = function setDefaultRequest(params) {
  return {
    type: SET_DEFAULT_REQUESTING,
    params,
  };
};

export const setDefaultRequestSuccess = function setDefaultRequestSuccess(
  data
) {
  return {
    type: SET_DEFAULT_REQUEST_SUCCESS,
    data,
  };
};

export const setDefaultRequestError = function setDefaultRequestError(error) {
  return {
    type: SET_DEFAULT_REQUEST_ERROR,
    error,
  };
};
